import React, { useState, useEffect, useReducer } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Table, IconButton, Icon, Row, Col, Whisper, Tooltip, ButtonGroup, Popover } from 'rsuite'
import EditSelectCell from '../../components/cell/EditSelectCell'
import EditTextCell from '../../components/cell/EditTextCell'
import EditNumberCell from '../../components/cell/EditNumberCell'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { budgetFormat } from '../../utils/formatterUtil'
import { cloneDeep } from 'lodash-es'
import notification from '../../utils/notification'
import { getValueFromOptions } from '../../utils/dataUtil'
import {
  getReceivedFrom,
  getReceivedFromById,
  downloadTaxWithholdingFile,
} from '../../redux/actions/incomeAndExpense'
import { downloadExpensesDurableArticlesFile } from '../../redux/actions/accountingExpenses'
import { sessionGetItemJSON } from '../../utils/sessionHelpers'
import ExpenseRecordDurableArticlesModal from './ExpenseRecordDurableArticlesModal'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import PayeeModalWidget from '../payee/PayeeModalWidget'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import '../../widgets/projectBasedItemsWidget/styles_table.less'
import { hasMinValidator } from '../../utils/ValidatorUtils'

export default function ExpenseRecordTable({
  schema,
  loading,
  register,
  errors,
  control,
  setError,
  setValue,
  getValues,
  clearErrors,
  waitSendTaxSelected,
  onAddNewData = () => {},
  isViewMode,
  isSendTax,
  isAddDisabled,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [tableData, setTableData] = useState([])
  const [masterTableData, setMasterTableData] = useState([])
  const [masterExpenseType, setMasterExpenseType] = useState([])
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [showModalDurableArticles, setShowModalDurableArticles] = useState(false)
  const [showModalExpenseFor, setShowModalExpenseFor] = useState(false)
  const [IsModalDurableArticlesViewOnly, setIsModalDurableArticlesViewOnly] = useState(false)
  const [IsModalModalExpenseForViewOnly, setIsModalModalExpenseForViewOnly] = useState(false)

  const [expenseForSchema, setExpenseForSchema] = useState()
  const [searchNameOrId, setSearchNameOrId] = useState()

  const [expenseForId, setEpenseForId] = useState()

  const [indexForEditExpenseFor, setIndexForEditExpenseFor] = useState()

  const [isSubprojectReceiver, setIsSubprojectReceiver] = useState(false)

  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  const projectCode = sessionStorage.getItem('projectCode')
  const periodInfo = sessionGetItemJSON('periodInfo')

  const _styleCellSummary = { backgroundColor: '#1f5581', color: '#fff', fontWeight: 'bold' }
  const styleHeaderCell = { whiteSpace: 'normal', wordBreak: 'break-word' }
  const alertIconStyle = {
    color: 'red',
    position: 'relative',
    zIndex: 99,
    top: -12,
    right: -9,
    // top: 4,
    // right: -9,
    // marginTop: 2,
    // marginLeft: 1,
  }
  const fs = localStorage.getItem('fontSize')

  const fixedValue = {
    durableArticlesTypeCode: '1800', //ค่าครุภัณฑ์
    subProjectTypeCode: '2000', //เงินสนับสนุนโครงการย่อยประเภทค่าตอบแทน
    subProjectTypeCode1: '2001', //เงินสนับสนุนโครงการย่อยประเภทค่าดำเนินการ
    subProjectTypeCode2: '2002', //รับเงินคืนโครงการย่อย
    waitSendTax: '4000', //ภาษีนำส่ง
    salary: '1000', //เงินเดือน
    compensation: '1100', //ค่าตอบแทน
  }

  useEffect(() => {
    if (schema?.values && schema?.values.length > 0) {
      let convertData = schema?.values?.map((item) => {
        return {
          ...item,
          expenseType: item.expensesType,
          expenseList: item.expensesName,
          activity: item.activityCode,
          expenseWithholding: item.expenseTotalTax,
          masterExpenseWithholding: item.expenseTotalTax,
          masterExpenseVat: item.expenseVat,
          expenseFor:
            typeof item.expensesTo == 'object'
              ? {
                  ...item.expensesTo,
                  vatRegister: item.expensesTo?.isVatRegister || false,
                  withholding: item.expensesTo?.isWithholding || false,
                }
              : null,

          subProjectInfo: item.subProjectCode,
          dutableArticles: item.durableArticlesData,
        }
      })
      setMasterTableData(convertData)
      setTableData(convertData)

      register('table', convertData || [])
      setValue('table', convertData || [])
    } else {
      register('table', [])
      setValue('table', [])
    }
  }, [schema.values])

  useEffect(() => {
    if (schema?.activityRelations && schema?.activityRelations?.length > 0) {
      let convertData = schema?.activityRelations?.map((item) => {
        return {
          ...item,
          label: item.typeName,
          value: item.typeCode,
        }
      })

      //convertData.sort((a, b) => parseInt(a.typeCode) - parseInt(b.typeCode))
      setMasterExpenseType(convertData || [])
    } else {
      let convertData = schema?.expenseType?.options.map((item) => {
        return {
          ...item,
          typeName: item.label,
          typeCode: item.value,
        }
      })
      setMasterExpenseType(convertData || [])
    }
  }, [schema.activityRelations])

  useEffect(() => {
    if (waitSendTaxSelected && waitSendTaxSelected.length > 0) {
      handleOnClickAddNewData(waitSendTaxSelected)
    }
  }, [waitSendTaxSelected])

  useEffect(() => {
    if (errors) {
      // console.log('errors', errors)
      let key = Object.keys(errors)
      if (key.length > 0) {
        notification.open('error', {
          title: 'กรุณากรอกข้อมูลให้ครบถ้วน',
          duration: 5000,
        })
      }
    }
  }, [errors])

  // const handleCallReceivedFrom = async (nameOrId, id) => {
  //   try {
  //     let response
  //     if (id) {
  //       response = await getReceivedFromById(id)
  //     } else {
  //       response = await getReceivedFrom(projectCode, nameOrId)
  //     }

  //     if (response) {
  //       if (id) {
  //         let _schema = { values: [response] }
  //         setExpenseForSchema(_schema)
  //         setShowModalExpenseFor(true)
  //         setTimeout(() => {
  //           forceUpdate()
  //         }, 500)
  //         return
  //       }
  //       setExpenseForSchema(response)
  //       setShowModalExpenseFor(true)
  //       setTimeout(() => {
  //         forceUpdate()
  //       }, 500)
  //     } else {
  //       notification.open('error', {
  //         title: DEFAULT_ERR_MSG,
  //       })
  //     }
  //   } catch (e) {
  //     console.log('e', e)
  //     if (e?.response?.data) {
  //       notification.open('error', {
  //         title: e.response.data.errorMessage || DEFAULT_ERR_MSG,
  //       })
  //     } else {
  //       notification.open('error', {
  //         title: DEFAULT_ERR_MSG,
  //       })
  //     }
  //   }
  // }

  const handleOpenEditRow = (rowData) => {
    // tableData.map((row) => {
    //   if (row.id == rowData.id) {
    //     const nextData = getNewDataEdit(tableData, row)
    //     setTableData(nextData)
    //   }
    // })
    const newData = tableData.map((row) => {
      if (row.id == rowData.id) {
        if (rowData.status && rowData.status == 'EDIT') {
          const master = masterTableData.find((item, index) => item.id == rowData.id)
          // row.incomeType = master?.incomeType
          // row.subProjectInfo = master?.subProjectInfo
          // row.bankAccount = master?.bankAccount
          // row.cashAccountOnHand = master?.cashAccountOnHand
          // row.amount = master?.amount
          // row.vat = master?.vat
          // row.withholding = master?.withholding
          // row.receivedAmount = master?.receivedAmount
          // row.attachPath = master?.attachPath
          let index = tableData.findIndex((item) => item.id === master.id)

          console.log('master', master)

          // setValue(`table[${index}].${schema.activity.name}`, master.activity)
          // setValue(`table[${index}].${'expensesTypeId'}`, master.expensesType?.typeCode)
          // setValue(`table[${index}].${schema.expenseList.name}`, master.expenseList)
          // setValue(`table[${index}].${schema.subProjectInfo.name}`, master.subProjectInfo)
          // setValue(`table[${index}].${schema.expensePrice.name}`, master.expensePrice)
          // setValue(`table[${index}].${schema.expenseVat.name}`, master.expenseVat)
          // setValue(`table[${index}].${schema.expenseTotalVat.name}`, master.expenseTotalVat)
          // setValue(`table[${index}].${schema.expenseWithholding.name}`, master.expenseWithholding)
          // setValue(`table[${index}].${schema.expenseTotal.name}`, master.expenseTotal)

          row = master
          row.status = null
        } else {
          row.status = 'EDIT'
        }
      }
      return row
    })

    handleChangeTotal(newData)
    // setTableData(newData)
    // setValue('table', newData)

    // setTimeout(() => {
    //   let datas = cloneDeep(newData)

    //   setTableData(datas)
    //   setValue('table', datas)
    //   forceUpdate()
    // }, 100)
  }

  const onDeleteRow = (rowData) => {
    let datas = cloneDeep(tableData)

    datas = datas.filter((e) => e.id != rowData.id)

    var sumObj = {}
    if (datas && datas?.length > 0) {
      sumObj = datas[datas.length - 1]

      sumObj.expensePrice = 0
      sumObj.expenseVat = 0
      sumObj.expenseTotalVat = 0
      sumObj.expenseWithholding = 0
      sumObj.expenseTotal = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        //activityId: '1',
        activity: '',
        //expenseTypeId: '',
        expenseType: 'รวมทั้งสิ้น',
        subProjectInfo: '',
        expenseFor: '',
        expensePrice: 0,
        expenseVat: 0,
        masterExpenseVat: 0,
        expenseTotalVat: 0,
        expenseWithholding: 0,
        masterExpenseWithholding: 0,
        expenseTotal: 0,
        isSummary: true,
      }
    }

    datas.forEach((e) => {
      sumObj.expensePrice = sumObj.expensePrice + e.expensePrice
      sumObj.expenseVat = sumObj.expenseVat + e.expenseVat
      sumObj.expenseTotalVat = sumObj.expenseTotalVat + e.expenseTotalVat
      sumObj.expenseWithholding = sumObj.expenseWithholding + e.expenseWithholding
      sumObj.expenseTotal = sumObj.expenseTotal + e.expenseTotal
    })

    datas.push(sumObj)
    setTableData(datas)
    setValue('table', datas)
    onAddNewData(datas)
  }

  const handleOnClickAddNewData = (waitSendTaxSelected) => {
    console.log('handleOnClickAddNewData waitSendTaxSelected : ', waitSendTaxSelected)
    // return false
    let totalWaitSendTax = 0
    let waitSendTaxTypeName = ''

    if (waitSendTaxSelected) {
      waitSendTaxSelected.forEach((item, index) => {
        totalWaitSendTax += item.tax
        var result = waitSendTaxSelected[index].transactionDate.split('/')

        let myArray = ''
        if (result.length > 0) {
          let text = result[0]
          myArray = text.split(' ')
        }

        if (index == 0) {
          // waitSendTaxTypeName = waitSendTaxTypeName + ', ' + result[0]
          waitSendTaxTypeName = item.taxType + ' ' + myArray[1] + ' ' + myArray[2]
        } else {
          if (waitSendTaxTypeName.indexOf(result[0]) == -1) {
            // waitSendTaxTypeName = waitSendTaxTypeName + ', ' + result[0]
            // waitSendTaxTypeName = waitSendTaxTypeName + ', ' + myArray[1] + ' ' + myArray[2]
            waitSendTaxTypeName = item.taxType + ' ' + myArray[1] + ' ' + myArray[2]
          }
        }
      })
    }

    // setTableData()
    let datas = cloneDeep(tableData)

    //var lasted = datas[datas.length-1]
    var runnigNum = 1
    var sumObj = {}
    if (datas && datas?.length > 0) {
      runnigNum = datas.length - 1
      sumObj = datas[datas.length - 1]

      sumObj.expensePrice = 0
      sumObj.expenseVat = 0
      sumObj.expenseTotalVat = 0
      sumObj.expenseWithholding = 0
      sumObj.expenseTotal = 0

      datas?.splice(-1)
    } else {
      datas = []

      sumObj = {
        id: '',
        //activityId: '1',
        activity: '',
        //expenseTypeId: '',
        expenseType: 'รวมทั้งสิ้น',
        subProjectInfo: '',
        expenseFor: '',
        expensePrice: 0,
        expenseVat: 0,
        expenseTotalVat: 0,
        expenseWithholding: 0,
        expenseTotal: 0,
        isSummary: true,
      }
    }
    let obj = masterExpenseType.filter((item) => item.value == fixedValue.waitSendTax)
    if (obj?.length == 0) {
      obj = null
    }

    let id
    if (waitSendTaxSelected) {
      id = 'addNew-sendTax-' + runnigNum + '-' + uuidv4()
    } else {
      id = 'addNew-' + runnigNum + '-' + uuidv4()
    }

    var newObj = {
      id: id,
      //activityId: '1',
      activity: '',
      //expenseTypeId: '',
      expenseType: waitSendTaxSelected ? (obj ? obj[0] : null) : '',
      expensesTypeId: waitSendTaxSelected ? fixedValue.waitSendTax : '',
      expenseList: waitSendTaxTypeName || '',
      subProjectInfo: '',
      expenseFor: '',
      expensePrice: waitSendTaxSelected ? totalWaitSendTax : 0,
      expenseVat: 0,
      masterExpenseVat: 0,
      expenseTotalVat: waitSendTaxSelected ? totalWaitSendTax : 0,
      expenseWithholding: 0,
      masterExpenseWithholding: 0,
      expenseTotal: waitSendTaxSelected ? totalWaitSendTax : 0,
      isDeleteDisabled: false,
      isEditDisabled: false,
      fileWithholdingTAX: null,
      status: 'EDIT',
      isWaitSendTax: waitSendTaxSelected ? true : false,
      waitSendTaxList: waitSendTaxSelected || [],
      isDisableActivity: false,
    }

    if (waitSendTaxSelected && datas.find((i) => i.id.indexOf('sendTax') > 0)) {
      let index = datas.findIndex((i) => i.id.indexOf('sendTax') > -1)

      // setValue(`table[${index}].${schema.activity.name}`, newObj.activity)
      // setValue(`table[${index}].${'expensesTypeId'}`, newObj.expenseType?.typeCode)
      // setValue(`table[${index}].${schema.expenseList.name}`, newObj.expenseList)
      // setValue(`table[${index}].${schema.subProjectInfo.name}`, newObj.subProjectInfo)
      // setValue(`table[${index}].${schema.expensePrice.name}`, newObj.expensePrice)
      // setValue(`table[${index}].${schema.expenseVat.name}`, newObj.expenseVat)
      // setValue(`table[${index}].${schema.expenseTotalVat.name}`, newObj.expenseTotalVat)
      // setValue(`table[${index}].${schema.expenseWithholding.name}`, newObj.expenseWithholding)
      // setValue(`table[${index}].${schema.expenseTotal.name}`, newObj.expenseTotal)

      datas.splice(index, 1, newObj)
    } else {
      datas.push(newObj)
    }

    datas.forEach((e) => {
      sumObj.expensePrice = sumObj.expensePrice + e.expensePrice
      sumObj.expenseVat = sumObj.expenseVat + e.expenseVat
      sumObj.expenseTotalVat = sumObj.expenseTotalVat + e.expenseTotalVat
      sumObj.expenseWithholding = sumObj.expenseWithholding + e.expenseWithholding
      sumObj.expenseTotal = sumObj.expenseTotal + e.expenseTotal
    })

    datas.push(sumObj)
    setTableData(datas)
    setValue('table', datas)
    onAddNewData(datas)
  }

  // const chkExpenseTypeCode = [
  //   '9300', //ค่าใช้จ่ายค้างจ่าย
  //   '5200', //คืนเงินยืมสำรองจากแหล่งอื่น
  //   '6600', //เงินฝาก
  //   '6100', //เงินสด
  //   '4200', //ดอกเบี้ยรับ
  //   '6701', //ภาษีถูกหัก ณ ที่จ่าย
  //   '6700', //ภาษีถูกหัก ณ ที่จ่าย (คู่สัญญา)
  //   '4000', //ภาษีนำส่ง
  //   '1200',
  // ]

  const handleExpenseType = (index, value, id) => {
    let datas = cloneDeep(tableData)

    console.log('handleExpenseType datas : ', datas)

    const chk = schema?.expenseType?.chkExpenseTypeCode

    if (Array.isArray(chk) && chk.includes(value)) {
      datas[index].activity = ''
      datas[index].isDisableActivity = true
      setValue(`${schema.activity.name}_${id}`, null)
    } else {
      datas[index].isDisableActivity = false
    }

    if (
      // value == fixedValue.subProjectTypeCode ||
      value == fixedValue.subProjectTypeCode1 ||
      value == fixedValue.subProjectTypeCode2
    ) {
      datas[index].subProjectInfo = schema?.subProjectInfo?.options[0]?.value || ''
      setValue(
        `table[${index}].${schema.subProjectInfo.name}`,
        schema?.subProjectInfo?.options[0]?.value || ''
      )
    } else {
      datas[index].subProjectInfo = ''
      setValue(`table[${index}].${schema.subProjectInfo.name}`, '')
    }

    //เช็คกรณีเปลี่ยนประเภทไปใช้ผู้รับเงินที่มีโครงการย่อย ให้เคลียร์ ผู้รับเงิน เลือกใหม่
    if (
      (value == fixedValue.subProjectTypeCode &&
        datas[index].expenseType?.typeCode != fixedValue.subProjectTypeCode) ||
      (value != fixedValue.subProjectTypeCode &&
        datas[index].expenseType?.typeCode == fixedValue.subProjectTypeCode)
    ) {
      datas[index].expenseFor = null
      setValue(`table[${index}].${schema.expenseFor.name}`, null)
    }

    let obj = masterExpenseType.filter((item) => item.value == value)
    if (obj?.length == 0) {
      obj = null
    }
    //console.log('obj ', obj ? obj[0] : null)
    datas[index].expenseType = obj ? obj[0] : null
    datas[index].expensesTypeId = obj ? obj[0]?.typeCode : null

    // if (
    //   datas[index].expenseType.typeCode == fixedValue.salary ||
    //   datas[index].expenseType.typeCode == fixedValue.compensation
    // ) {
    //   if (datas[index].expenseFor.withholding && datas[index].expenseType.taxType) {
    //     //คิดตาม rate ที่หลังบ้านส่งมา
    //     let tax = calcurateTax(datas[index]?.expensePrice, datas[index].expenseType.taxRate) || 0
    //     datas[index].expenseWithholding = tax
    //     datas[index].masterExpenseWithholding = tax
    //     setValue(`${schema.expenseWithholding.name}_${id}`, tax)
    //   } else {
    //     datas[index].expenseWithholding = 0
    //     datas[index].masterExpenseWithholding = 0
    //     setValue(`${schema.expenseWithholding.name}_${id}`, 0)
    //   }
    // } else {
    //   //เช็คว่า price >= datas[index].expenseFor.minimum ? คิดตาม taxRate : ไม่ต้องคิด tax
    //   if (
    //     datas[index]?.expensePrice >= datas[index].expenseFor.minimum &&
    //     datas[index].expenseType.taxType
    //   ) {
    //     //คิดตาม taxRate เพราะยอดเกิน minimum
    //     let tax = calcurateTax(datas[index]?.expensePrice, datas[index].expenseType.taxRate) || 0
    //     datas[index].expenseWithholding = tax
    //     datas[index].masterExpenseWithholding = tax
    //     setValue(`${schema.expenseWithholding.name}_${id}`, tax)
    //   } else {
    //     //ไม่ต้องคิด tax เพราะยอดไม่ถึง minimum
    //     datas[index].expenseWithholding = 0
    //     datas[index].masterExpenseWithholding = 0
    //     setValue(`${schema.expenseWithholding.name}_${id}`, 0)
    //   }
    // }

    // datas[index].expenseTotal = datas[index].expensePrice - datas[index].expenseWithholding || 0
    // setValue(
    //   `${schema.expenseTotal.name}_${id}`,
    //   datas[index].expensePrice - datas[index].expenseWithholding || 0
    // )

    //handleChangeTotal(datas)
    handleChangeExpensePrice(index, datas[index].expensePrice, datas[index].id, datas)

    if (value == fixedValue.durableArticlesTypeCode) {
      setIndexForEditExpenseFor(index)
      setShowModalDurableArticles(true)
      setIsModalDurableArticlesViewOnly(false)
    }
  }

  const cancelShowModalDurableArticles = () => {
    setShowModalDurableArticles(false)
  }

  const cancelShowModalExpenseFor = () => {
    setShowModalExpenseFor(false)
  }

  const onChangeTableValue = (index, value, key) => {
    let datas = cloneDeep(tableData)

    datas[index][key] = value

    setTableData(datas)
    setValue('table', datas)

    // if (key == schema.activity.name) {
    //   setTableData(datas)
    // }
  }

  // const handleClickExpenseFor = (rowData, index) => {
  //   handleCallReceivedFrom(null)
  //   setSearchNameOrId('')
  //   setIndexForEditExpenseFor(index)
  //   setIsModalModalExpenseForViewOnly(false)
  //   //setShowModalExpenseFor(true)
  // }

  const handleSelectVender = (dataRow) => {
    var datas = cloneDeep(tableData)
    // var _rowData = datas[indexForEditExpenseFor]

    // _rowData.expenseFor = dataRow

    datas[indexForEditExpenseFor].expenseFor = dataRow

    console.log('dataRow', dataRow)

    // setTableData(datas)
    // setValue('table', datas)
    handleChangeExpensePrice(
      indexForEditExpenseFor,
      datas[indexForEditExpenseFor].expensePrice,
      datas[indexForEditExpenseFor].id,
      datas
    )

    setShowModalExpenseFor(false)
    setIsModalModalExpenseForViewOnly(false)
  }

  const handleSubmitDurableArticles = (data) => {
    console.log('data', data)
    var datas = cloneDeep(tableData)
    var _rowData = datas[indexForEditExpenseFor]

    _rowData.dutableArticles = data

    datas[indexForEditExpenseFor] = _rowData

    // setTableData(datas)
    // setValue('table', datas)

    console.log('_rowData', _rowData)

    let totalPrice = data.durableArticlesAmount * data.durableArticlesPrice

    handleChangeExpensePrice(
      indexForEditExpenseFor,
      totalPrice,
      datas[indexForEditExpenseFor].id,
      datas
    )

    //setReceiveMoneyEtcVal(dataRow?.name)
    //setValue(formSchema?.receiveMoneyEtc?.name, dataRow?.id)
    //clearErrors(formSchema?.receiveMoneyEtc?.name)
    setShowModalDurableArticles(false)
    setIsModalDurableArticlesViewOnly(false)
  }

  const onPreview = async (filePath, fileName) => {
    startLoading()
    try {
      var file = await downloadExpensesDurableArticlesFile(filePath)

      previewFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownload = async (filePath, fileName) => {
    startLoading()
    try {
      var file = await downloadExpensesDurableArticlesFile(filePath)

      downloadFile(file, fileName)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const calcurateVat = (value) => {
    if (value) {
      let vat = 0
      vat = value * 0.07
      return parseFloat(vat.toFixed(2))
      // let vat = 0
      // vat = (value * 7) / 107
      // return parseFloat(vat.toFixed(2))
    }
  }

  const calcurateTax = (value, taxRate = 0) => {
    if (value) {
      let tax = 0
      tax = value * (taxRate / 100)
      return parseFloat(tax.toFixed(2))
    }
  }

  // มูลค่าสินค้า/ค่าใช้จ่าย
  const handleChangeExpensePrice = (index, value = 0, id, datasTable) => {
    let datas
    if (datasTable) {
      datas = cloneDeep(datasTable)
    } else {
      datas = cloneDeep(tableData)
    }

    if (datas[index].expenseFor?.vatRegister) {
      let vat = calcurateVat(value) || 0
      datas[index].expenseVat = vat
      datas[index].masterExpenseVat = vat
      setValue(`${schema.expenseVat.name}_${id}`, vat)
    } else {
      datas[index].expenseVat = 0
      datas[index].masterExpenseVat = 0
      setValue(`${schema.expenseVat.name}_${id}`, 0)
    }

    if (
      datas[index].expenseType?.typeCode == fixedValue.salary ||
      datas[index].expenseType?.typeCode == fixedValue.compensation ||
      datas[index].expenseType?.typeCode == fixedValue.subProjectTypeCode ||
      datas[index].expenseType?.typeCode == fixedValue.subProjectTypeCode1 ||
      datas[index].expenseType?.typeCode == fixedValue.subProjectTypeCode2
    ) {
      if (
        (datas[index].expenseFor?.withholding ||
          datas[index].expenseType.typeCode == fixedValue.subProjectTypeCode ||
          datas[index].expenseType.typeCode == fixedValue.subProjectTypeCode1 ||
          datas[index].expenseType.typeCode == fixedValue.subProjectTypeCode2) &&
        datas[index].expenseType.taxType
      ) {
        //คิดตาม rate ที่หลังบ้านส่งมา
        let tax = calcurateTax(value, datas[index].expenseType.taxRate) || 0
        datas[index].expenseWithholding = tax
        datas[index].masterExpenseWithholding = tax
        setValue(`${schema.expenseWithholding.name}_${id}`, tax)
      } else {
        datas[index].expenseWithholding = 0
        datas[index].masterExpenseWithholding = 0
        setValue(`${schema.expenseWithholding.name}_${id}`, 0)
      }
    } else {
      //เช็คว่า price >= datas[index].expenseFor.minimum ? คิดตาม taxRate : ไม่ต้องคิด tax
      if (value >= datas[index]?.expenseFor?.minimum && datas[index]?.expenseType?.taxType) {
        //คิดตาม taxRate เพราะยอดเกิน minimum
        let tax = calcurateTax(value, datas[index].expenseType?.taxRate) || 0
        datas[index].expenseWithholding = tax
        datas[index].masterExpenseWithholding = tax
        setValue(`${schema.expenseWithholding.name}_${id}`, tax)
      } else {
        //ไม่ต้องคิด tax เพราะยอดไม่ถึง minimum
        datas[index].expenseWithholding = 0
        datas[index].masterExpenseWithholding = 0
        setValue(`${schema.expenseWithholding.name}_${id}`, 0)
      }
    }

    let totalVat = value + datas[index].expenseVat

    datas[index].expensePrice = value
    setValue(`table[${index}].${schema.expensePrice.name}`, value)
    datas[index].expenseTotalVat = totalVat
    // setValue(`table[${index}].${schema.expenseTotalVat.name}`, totalVat)

    // console.log('มูลค่าสินค้า/ค่าใช้จ่าย (ราคาสุทธิไม่รวม VAT)', value)
    // console.log('ภาษีมูลค่าเพิ่ม', datas[index].expenseVat)
    // console.log('ราคารวมภาษีมูลค่าเพิ่ม', totalVat)
    // console.log('หัก ภาษี ณ ที่จ่าย', datas[index].expenseWithholding)
    // console.log(
    //   'คงเหลือเบิกจ่ายสุทธิ = มูลค่าสินค้า/ค่าใช้จ่าย (ราคาสุทธิไม่รวม VAT) + ภาษีมูลค่าเพิ่ม - หัก ภาษี ณ ที่จ่าย',
    //   value + datas[index].expenseVat - datas[index].expenseWithholding
    // )
    datas[index].expenseTotal =
      value + datas[index].expenseVat - datas[index].expenseWithholding || 0
    setValue(
      `${schema.expenseTotal.name}_${id}`,
      value + datas[index].expenseVat - datas[index].expenseWithholding || 0
    )

    //setTableData(datas)
    // setValue('table', datas)

    //handleChangeExpenseTotalVat(index, totalVat)

    handleChangeTotal(datas)
  }

  //ภาษีมูลค่าเพิ่ม (Vat)
  const handleChangeExpenseVat = (index, value = 0, id) => {
    let datas = cloneDeep(tableData)

    let totalVat = value + datas[index].expensePrice

    datas[index].expenseVat = value
    // setValue(`table[${index}].${schema.expenseVat.name}`, value)
    datas[index].expenseTotalVat = totalVat
    datas[index].expenseTotal = totalVat - datas[index].expenseWithholding
    // setValue(`table[${index}].${schema.expenseTotalVat.name}`, totalVat)

    // datas[index].expenseTotal = totalVat - datas[index].expenseWithholding || 0
    // setValue(`${schema.expenseTotal.name}_${id}`, totalVat - datas[index].expenseWithholding || 0)
    //setTableData(datas)
    // setValue('table', datas)

    //handleChangeExpenseTotalVat(index, totalVat)
    handleChangeTotal(datas)
  }

  //ราคารวมภาษีมูลค่าเพิ่ม
  const handleChangeExpenseTotalVat = (index, value = 0) => {
    let datas = cloneDeep(tableData)

    let expenseTotal = value - datas[index].expenseWithholding

    datas[index].expenseTotalVat = value
    // setValue(`table[${index}].${schema.expenseTotalVat.name}`, value)
    datas[index].expenseTotal = expenseTotal
    // setValue(`table[${index}].${schema.expenseTotal.name}`, expenseTotal)
    //setTableData(datas)
    // setValue('table', datas)

    handleChangeTotal(datas)
  }

  //หัก ภาษี ณ ที่จ่าย (withholdingTax)
  const handleChangeExpenseWithholding = (index, value = 0) => {
    let datas = cloneDeep(tableData)

    //let expenseTotal = datas[index].expensePrice - value
    let expenseTotal = datas[index].expenseTotalVat - value

    datas[index].expenseWithholding = value
    // setValue(`table[${index}].${schema.expenseWithholding.name}`, value)
    datas[index].expenseTotal = expenseTotal
    // setValue(`table[${index}].${schema.expenseTotal.name}`, expenseTotal)
    //setTableData(datas)
    // setValue('table', datas)

    handleChangeTotal(datas)
  }

  const handleChangeTotal = (dataTable) => {
    if (dataTable?.length > 0) {
      var totalExpensePrice = 0
      var totalExpenseVat = 0
      var totalExpenseTotalVat = 0
      var totalExpenseWithholding = 0
      var totalExpenseTotal = 0

      dataTable.forEach((e) => {
        if (!e.isSummary) {
          if (e.activity) {
            var activityCostAmount =
              masterExpenseType?.find((ex) => ex.activityCode == e.activity)?.activityCostAmount ||
              0

            e['isOver'] = e.expenseTotalVat > activityCostAmount
            e['activityCostAmount'] = activityCostAmount
          }

          totalExpensePrice = totalExpensePrice + e.expensePrice
          totalExpenseVat = totalExpenseVat + e.expenseVat
          totalExpenseTotalVat = totalExpenseTotalVat + e.expenseTotalVat
          totalExpenseWithholding = totalExpenseWithholding + e.expenseWithholding
          totalExpenseTotal = totalExpenseTotal + e.expenseTotal
        }
      })

      dataTable[dataTable.length - 1].expensePrice = totalExpensePrice
      dataTable[dataTable.length - 1].expenseVat = totalExpenseVat
      dataTable[dataTable.length - 1].expenseTotalVat = totalExpenseTotalVat
      dataTable[dataTable.length - 1].expenseWithholding = totalExpenseWithholding
      dataTable[dataTable.length - 1].expenseTotal = totalExpenseTotal

      setTableData(dataTable)
      setValue('table', dataTable)

      // setValue(`table[${dataTable.length - 1}].${schema.expensePrice.name}`, totalExpensePrice)
      // setValue(`table[${dataTable.length - 1}].${schema.expenseVat.name}`, totalExpenseVat)
      // setValue(`table[${dataTable.length - 1}].${schema.expenseWithholding.name}`, totalExpenseWithholding)
      // setValue(`table[${dataTable.length - 1}].${schema.expenseTotal.name}`, totalExpenseTotal)
    }
  }

  const onPreviewTaxWithholding = async (rowData) => {
    // console.log('onPreviewTaxWithholding ', rowData)

    startLoading()
    try {
      var file = await downloadTaxWithholdingFile(rowData.id)

      previewFile(file, `หนังสือรับรองการหักภาษี_ณ_ที่จ่าย_${rowData.id}`)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onDownloadTaxWithholding = async (rowData) => {
    // console.log('onDownloadTaxWithholding ', rowData)

    startLoading()
    try {
      var file = await downloadTaxWithholdingFile(rowData.id)

      downloadFile(file, `หนังสือรับรองการหักภาษี_ณ_ที่จ่าย_${rowData.id}`)
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  return (
    <>
      <div className="table-affix-header">
        <Table
          shouldUpdateScroll={false}
          wordWrap
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: '20px' }}
          headerHeight={fs <= 15 ? 60 : fs <= 16 ? 70 : fs <= 18 ? 100 : 110}
          affixHeader
        >
          <Column width={70} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return ''
                }

                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={250} minWidth={250} flexGrow={1}>
            <HeaderCell>จ่ายให้กิจกรรม</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.status != 'EDIT') {
                  return getValueFromOptions(schema?.activity?.options, rowData?.activity) //rowData.incomeType
                }

                return (
                  <EditSelectCell
                    id={`${schema.activity.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.activity.name}`}
                    rowData={rowData}
                    rowSchema={schema.activity}
                    dataKey={schema.activity.name}
                    register={register}
                    control={control}
                    errors={errors}
                    disabled={
                      rowData.expenseType?.typeCode == fixedValue.waitSendTax ||
                      rowData.isWaitSendTax ||
                      rowData.isDisableActivity
                    }
                    searchable={true}
                    onChangeCell={(value) => onChangeTableValue(index, value, schema.activity.name)}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell>รายการ/ประเภทค่าใช้จ่าย</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{rowData.expenseType || 'รวมทั้งสิ้น'}</b>
                }

                if (rowData.status != 'EDIT') {
                  return (
                    <>
                      <Col
                        xs={
                          rowData?.expenseType?.typeCode == fixedValue.durableArticlesTypeCode
                            ? 18
                            : 24
                        }
                      >
                        <span>
                          {getValueFromOptions(masterExpenseType, rowData?.expenseType?.typeCode)}
                        </span>
                      </Col>
                      {rowData?.expenseType?.typeCode == fixedValue.durableArticlesTypeCode && (
                        <Col xs={6}>
                          <TooltipButton
                            isStart={true}
                            icon="eye"
                            tooltip={`ดูครุภัณฑ์`}
                            // disabled={loading}
                            onClick={(e) => {
                              setShowModalDurableArticles(true)
                              setIndexForEditExpenseFor(index)
                              setIsModalDurableArticlesViewOnly(true)
                            }}
                          ></TooltipButton>
                        </Col>
                      )}
                    </>
                  )
                }

                return (
                  <>
                    <Col
                      xs={
                        rowData?.expenseType?.typeCode == fixedValue.durableArticlesTypeCode
                          ? 18
                          : 24
                      }
                    >
                      <EditSelectCell
                        id={`${schema.expenseType.name}_${rowData.id}`}
                        //id={`table[${index}].${'expensesTypeId'}`}
                        rowData={rowData}
                        //rowSchema={schema.activity}
                        rowSchema={{
                          ...schema.expenseType,
                          options: [
                            /*
                          ...new Map(
                            masterExpenseType
                              // .filter((i) => rowData.activity == i.activityCode || !i.activityCode)
                              .filter((i) => rowData.activity == i.activityCode || !i.activityCode)
                              ?.map((item) => [item['typeCode'], item])
                          ).values(),
                          */
                            ...(rowData.activity
                              ? new Map(
                                  masterExpenseType
                                    .filter((i) => rowData.activity == i.activityCode)
                                    ?.map((item) => [item['typeCode'], item])
                                ).values()
                              : tableData.find((i) => i.id.indexOf('sendTax') > 0) || isSendTax
                                ? schema.expenseType.options.filter(
                                    (option) => option.value == fixedValue.waitSendTax
                                  )
                                : schema.expenseType.options),
                          ],
                        }}
                        //dataKey={schema.expenseType.name}
                        dataKey={'expensesTypeId'}
                        register={register}
                        control={control}
                        errors={errors}
                        disabled={false}
                        searchable={true}
                        onChangeCell={(value) => handleExpenseType(index, value, rowData.id)}
                        disabledItemValues={
                          !(tableData.find((i) => i.id.indexOf('sendTax') > 0) || isSendTax)
                            ? [fixedValue.waitSendTax]
                            : []
                        }
                      />
                    </Col>

                    {rowData?.expenseType?.typeCode == fixedValue.durableArticlesTypeCode && (
                      <Col xs={6}>
                        <TooltipButton
                          isStart={true}
                          icon="edit"
                          tooltip={`แก้ไขค่าครุภัณฑ์`}
                          iconStyle={{ backgroundColor: '#EEB189', borderRadius: 'inherit' }}
                          // disabled={loading}
                          onClick={(e) => {
                            setShowModalDurableArticles(true)
                            setIndexForEditExpenseFor(index)
                            setIsModalDurableArticlesViewOnly(false)
                          }}
                        ></TooltipButton>
                      </Col>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>

          <Column width={250}>
            <HeaderCell>รายการ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{rowData.expenseList}</b>
                }

                return (
                  <EditTextCell
                    id={`${schema.expenseList.name}_${rowData.id}`}
                    //id={`table[${index}].${schema.expenseList.name}`}
                    rowSchema={schema.expenseList}
                    rowData={rowData}
                    dataKey={schema.expenseList.name}
                    register={register}
                    control={control}
                    errors={errors}
                    onChangeCell={(value) =>
                      onChangeTableValue(index, value, schema.expenseList.name)
                    }
                    isRequired={false}
                    // isBudgetFormat={true}
                    // styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  />
                )
              }}
            </Cell>
          </Column>

          <Column width={180}>
            <HeaderCell>ผู้รับเงิน</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return ''
                }

                if (
                  //โครงจ่ายให้การย่อย
                  // rowData?.expenseType?.typeCode == fixedValue.subProjectTypeCode ||
                  rowData?.expenseType?.typeCode == fixedValue.subProjectTypeCode1 ||
                  rowData?.expenseType?.typeCode == fixedValue.subProjectTypeCode2
                ) {
                  if (rowData.status != 'EDIT') {
                    return getValueFromOptions(
                      schema?.subProjectInfo?.options,
                      rowData?.subProjectInfo
                    ) //rowData.incomeType
                  }

                  return (
                    <EditSelectCell
                      id={`${schema.subProjectInfo.name}_${rowData.id}`}
                      //id={`table[${index}].${schema.subProjectInfo.name}`}
                      rowData={rowData}
                      rowSchema={schema.subProjectInfo}
                      dataKey={schema.subProjectInfo.name}
                      register={register}
                      control={control}
                      errors={errors}
                      onChangeCell={(value) =>
                        onChangeTableValue(index, value, schema.subProjectInfo.name)
                      }
                    />
                  )
                } else {
                  if (isViewMode) {
                    if (rowData.expenseType?.typeCode != fixedValue.waitSendTax) {
                      return rowData.expenseFor?.name || ''
                    } else {
                      return <span>{'กรมสรรพกร'}</span>
                    }
                  }

                  return (
                    <>
                      {rowData.expenseType?.typeCode != fixedValue.waitSendTax ? (
                        !rowData.isWaitSendTax && ( // ดู เลือกผู้รับเงิน
                          <Row key={index}>
                            <Col xs={18}>{rowData.expenseFor?.name}</Col>

                            {rowData.status != 'EDIT' ? (
                              <Col xs={6}>
                                <TooltipButton
                                  isStart={true}
                                  icon="eye"
                                  tooltip={`ดูผู้รับเงิน`}
                                  disabled={!rowData.expenseFor.id}
                                  buttonClass="rs-btn-save"
                                  iconClass={'bt-gost-icon-radius-all'}
                                  onClick={(e) => {
                                    // handleCallReceivedFrom('', rowData.expenseFor.id)
                                    setEpenseForId(rowData?.expenseFor?.id)
                                    //setSearchNameOrId(rowData?.expenseFor?.id)
                                    setIndexForEditExpenseFor(index)
                                    setIsModalModalExpenseForViewOnly(true)
                                    setShowModalExpenseFor(true)

                                    if (
                                      rowData?.expenseType?.typeCode ==
                                      fixedValue.subProjectTypeCode
                                    ) {
                                      setIsSubprojectReceiver(true)
                                    } else {
                                      setIsSubprojectReceiver(false)
                                    }
                                  }}
                                ></TooltipButton>
                              </Col>
                            ) : (
                              <Col xs={6}>
                                <TooltipButton
                                  isStart={true}
                                  icon="edit"
                                  tooltip={`เลือกผู้รับเงิน`}
                                  buttonClass="rs-btn-ghost-edit"
                                  iconClass={'bt-gost-icon-radius-all-edit'}
                                  // disabled={loading}
                                  onClick={(e) => {
                                    // handleCallReceivedFrom(null)
                                    //setSearchNameOrId('')
                                    setEpenseForId('')
                                    setIndexForEditExpenseFor(index)
                                    setIsModalModalExpenseForViewOnly(false)
                                    setShowModalExpenseFor(true)

                                    if (
                                      rowData?.expenseType?.typeCode ==
                                      fixedValue.subProjectTypeCode
                                    ) {
                                      setIsSubprojectReceiver(true)
                                    } else {
                                      setIsSubprojectReceiver(false)
                                    }
                                  }}
                                ></TooltipButton>
                                {/* <Button size="xs" onClick={() => handleClickExpenseFor(rowData, index)}>
                          ...
                        </Button> */}
                              </Col>
                            )}
                          </Row>
                        )
                      ) : (
                        //ภาษีนำส่ง
                        <span>{'กรมสรรพกร'}</span>
                      )}
                    </>
                  )
                }
              }}
            </Cell>
          </Column>

          <Column width={180} align="right">
            <HeaderCell>
              <div style={styleHeaderCell}>มูลค่าสินค้า/ค่าใช้จ่าย (ราคาสุทธิไม่รวม VAT)</div>
            </HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{budgetFormat(rowData.expensePrice)}</b>
                }

                if (rowData?.expenseType?.typeCode == fixedValue.durableArticlesTypeCode) {
                  return (
                    <Controller
                      name={`table[${index}].${schema.expensePrice.name}`}
                      control={control}
                      defaultValue={rowData.expensePrice || 0}
                      render={(props) => {
                        return <span>{budgetFormat(rowData.expensePrice)}</span>
                      }}
                    />
                  )
                } else {
                  return (
                    <EditNumberCell
                      id={`${schema.expensePrice.name}_${rowData.id}`}
                      //id={`table[${index}].${schema.expensePrice.name}`}
                      rowData={rowData}
                      dataKey={schema.expensePrice.name}
                      register={register}
                      control={control}
                      errors={errors}
                      isRequired={true}
                      isBudgetFormat={true}
                      styleSheet={{ marginTop: 8, textAlign: 'right' }}
                      onChangeCell={(value) => handleChangeExpensePrice(index, value, rowData.id)}
                      disabled={rowData.expenseType?.typeCode == fixedValue.waitSendTax}
                      allowNegative={!hasMinValidator(schema.expensePrice.validators)}
                      // disabled={
                      //   rowData.expensesTypeId == '4000' ? true :
                      //   (tableData.find((i) => i.id.indexOf('sendTax') > 0) || isSendTax) && true
                      // }
                    />
                  )
                }
              }}
            </Cell>
          </Column>

          <Column width={150} align="right">
            <HeaderCell>ภาษีมูลค่าเพิ่ม</HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{budgetFormat(rowData.expenseVat)}</b>
                }

                return (
                  <>
                    {rowData.expenseVat != rowData.masterExpenseVat && (
                      <Whisper
                        placement="top"
                        trigger="hover"
                        speaker={
                          <Popover style={{ color: 'red', backgroundColor: '#FFF8E7' }}>
                            มีการเปลี่ยนแปลงภาษีมูลค่าเพิ่ม
                          </Popover>
                        }
                      >
                        <Icon size="2x" style={alertIconStyle} icon={'exclamation-circle'} />
                      </Whisper>
                    )}

                    <EditNumberCell
                      id={`${schema.expenseVat.name}_${rowData.id}`}
                      //id={`table[${index}].${schema.expenseVat.name}`}
                      rowData={rowData}
                      dataKey={schema.expenseVat.name}
                      register={register}
                      control={control}
                      errors={errors}
                      isRequired={true}
                      isBudgetFormat={true}
                      styleSheet={{ marginTop: 8, textAlign: 'right' }}
                      onChangeCell={(value) => handleChangeExpenseVat(index, value, rowData.id)}
                      disabled={
                        rowData.expenseType?.typeCode == fixedValue.waitSendTax
                          ? true
                          : !rowData?.expenseFor?.vatRegister
                      }
                      allowNegative={!hasMinValidator(schema.expenseVat.validators)}
                      // disabled={
                      //   tableData.find((i) => i.id.indexOf('sendTax') > 0) || isSendTax
                      //     ? true
                      //     : !rowData?.expenseFor?.vatRegister
                      // }
                    />
                  </>
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="right">
            <HeaderCell>
              <div style={styleHeaderCell}>ราคารวมภาษีมูลค่าเพิ่ม</div>
            </HeaderCell>
            <Cell align="right">
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{budgetFormat(rowData.expenseTotalVat)}</b>
                }

                return (
                  <Controller
                    name={`${schema.expenseTotalVat.name}_${rowData.id}`}
                    //name={`table[${index}].${schema.expenseTotalVat.name}`}
                    control={control}
                    defaultValue={rowData.expenseTotalVat || 0}
                    render={(props) => {
                      if (rowData.isOver) {
                        return (
                          <Whisper
                            placement="top"
                            trigger="hover"
                            //open={true}
                            speaker={
                              <Popover style={{ color: 'red', backgroundColor: '#FFF8E7' }}>
                                จำนวนเงินเกินค่าใช้จ่ายคงเหลือของกิจกรรม
                                <br />
                                ค่าใช้จ่ายคงเหลือของกิจกรรม{' '}
                                {budgetFormat(rowData.activityCostAmount)} บาท
                              </Popover>
                            }
                          >
                            <div>
                              <span style={{ color: 'red' }}>
                                {budgetFormat(rowData.expenseTotalVat)}
                              </span>
                            </div>
                          </Whisper>
                        )
                      }
                      // if (rowData?.activity) {
                      //   var activityCostAmount =
                      //     masterExpenseType?.find((e) => e.activityCode == rowData.activity)
                      //       ?.activityCostAmount || 0

                      //   if (rowData.expenseTotalVat > activityCostAmount) {
                      //     return (
                      //       <Whisper
                      //         placement="top"
                      //         trigger="none"
                      //         open={true}
                      //         speaker={
                      //           <Tooltip>
                      //             จำนวนเงินเกินค่าใช้จ่ายคงเหลือของกิจกรรม
                      //             <br />
                      //             ค่าใช้จ่ายคงเหลือของกิจกรรม {budgetFormat(activityCostAmount)} บาท
                      //           </Tooltip>
                      //         }
                      //       >
                      //         <span style={{ color: 'red' }}>
                      //           {budgetFormat(rowData.expenseTotalVat)}
                      //         </span>
                      //       </Whisper>
                      //     )
                      //   }
                      // }

                      return <span>{budgetFormat(rowData.expenseTotalVat)}</span>
                    }}
                  />
                  // <EditNumberCell
                  //   //id={`${schema.expenseTotalVat.name}_${rowData.id}`}
                  //   id={`table[${index}].${schema.expenseTotalVat.name}`}
                  //   rowData={rowData}
                  //   dataKey={schema.expenseTotalVat.name}
                  //   register={register}
                  //   control={control}
                  //   errors={errors}
                  //   isRequired={true}
                  //   isBudgetFormat={true}
                  //   styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  //   onChangeCell={(value) => handleChangeExpenseTotalVat(index, value)}
                  // />
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="right">
            <HeaderCell>หัก ภาษี ณ ที่จ่าย</HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{budgetFormat(rowData.expenseWithholding)}</b>
                }

                return (
                  // <Controller
                  //   name={`table[${index}].${schema.expenseWithholding.name}`}
                  //   control={control}
                  //   defaultValue={rowData.expenseWithholding || 0}
                  //   render={(props) => {
                  //     return <span>{budgetFormat(rowData.expenseWithholding)}</span>
                  //   }}
                  // />
                  <>
                    {rowData.expenseWithholding != rowData.masterExpenseWithholding && (
                      <Whisper
                        placement="top"
                        trigger="hover"
                        speaker={
                          <Popover style={{ color: 'red', backgroundColor: '#FFF8E7' }}>
                            มีการเปลี่ยนแปลงภาษีหัก ณ ที่จ่าย
                          </Popover>
                        }
                      >
                        <Icon size="2x" style={alertIconStyle} icon={'exclamation-circle'} />
                      </Whisper>
                    )}
                    <EditNumberCell
                      id={`${schema.expenseWithholding.name}_${rowData.id}`}
                      //id={`table[${index}].${schema.expenseWithholding.name}`}
                      rowData={rowData}
                      dataKey={schema.expenseWithholding.name}
                      register={register}
                      control={control}
                      errors={errors}
                      isRequired={true}
                      isBudgetFormat={true}
                      styleSheet={{ marginTop: 8, textAlign: 'right' }}
                      onChangeCell={(value) => handleChangeExpenseWithholding(index, value)}
                      disabled={
                        rowData.expenseType?.typeCode == fixedValue.salary ||
                        rowData.expenseType?.typeCode == fixedValue.compensation
                          ? !rowData?.expenseFor?.withholding
                          : !rowData?.expenseType?.taxRate > 0
                      }
                      allowNegative={!hasMinValidator(schema.expenseWithholding.validators)}
                      // allowNegative={true}
                      //disabled={!rowData?.expenseFor?.withholding}
                    />
                  </>
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="right">
            <HeaderCell>
              <div style={styleHeaderCell}>คงเหลือเบิกจ่ายสุทธิ</div>
            </HeaderCell>
            <Cell>
              {(rowData, index) => {
                if (rowData.isSummary) {
                  return <b>{budgetFormat(rowData.expenseTotal)}</b>
                }

                let data = getValues('table')

                return (
                  <Controller
                    name={`${schema.expenseTotal.name}_${rowData.id}`}
                    //name={`table[${index}].${schema.expenseTotal.name}`}
                    control={control}
                    defaultValue={rowData.expenseTotal || 0}
                    render={(props) => {
                      return <span>{budgetFormat(rowData.expenseTotal)}</span>
                    }}
                  />
                  // <EditNumberCell
                  //   //id={`${schema.expenseTotal.name}_${rowData.id}`}
                  //   id={`table[${index}].${schema.expenseTotal.name}`}
                  //   rowData={rowData}
                  //   dataKey={schema.expenseTotal.name}
                  //   register={register}
                  //   control={control}
                  //   errors={errors}
                  //   isRequired={true}
                  //   isBudgetFormat={true}
                  //   styleSheet={{ marginTop: 8, textAlign: 'right' }}
                  // />
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          {!isViewMode && (
            <Column width={180} align="center" fixed="right">
              <HeaderCell>จัดการรายการ</HeaderCell>
              <Cell align="center">
                {(rowData, index) => {
                  if (rowData.isSummary) {
                    return ''
                  }

                  return (
                    <>
                      {rowData.id?.indexOf('addNew') == -1 && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          icon={
                            <Icon
                              icon={rowData.status == 'EDIT' ? 'close' : 'edit'}
                              className="bt-gost-icon-radius-edit"
                            />
                          }
                          onClick={() => handleOpenEditRow(rowData)}
                          disabled={rowData.isEditDisabled}
                          size="sm"
                        >
                          {rowData.status == 'EDIT' ? 'ยกเลิก' : 'แก้ไข'}
                        </IconButton>
                      )}
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={() => {
                          onDeleteRow(rowData)
                        }}
                        disabled={rowData.isDeleteDisabled}
                        size="sm"
                        style={{ marginLeft: 5 }}
                      >
                        ลบ
                      </IconButton>
                    </>
                  )
                }}
              </Cell>
            </Column>
          )}

          {masterTableData.find(
            (i) => i.expenseWithholding > 0 && i.id?.indexOf('addNew') == -1
          ) && (
            <Column width={120} align="center" fixed="right">
              <HeaderCell>หนังสือรับรองการหักภาษี</HeaderCell>
              <Cell align="center">
                {(rowData, index) => {
                  if (rowData.isSummary) {
                    return ''
                  }

                  return (
                    masterTableData[index]?.expenseWithholding > 0 &&
                    rowData.id?.indexOf('addNew') == -1 && (
                      <ButtonGroup>
                        <TooltipButton
                          isStart={true}
                          icon="eye"
                          tooltip={`แสดง`}
                          // disabled={loading}
                          onClick={(e) => onPreviewTaxWithholding(rowData)}
                        ></TooltipButton>
                        <TooltipButton
                          isStart={false}
                          icon="download"
                          tooltip={`ดาวน์โหลด`}
                          // disabled={loading}
                          onClick={(e) => onDownloadTaxWithholding(rowData)}
                        ></TooltipButton>
                      </ButtonGroup>
                    )
                  )

                  // if (rowData.isSummary) {
                  //   return ''
                  // }

                  // if (!rowData.fileWithholdingTAX) {
                  //   return (
                  //     <>
                  //       <Uploader
                  //         multiple={false}
                  //         listType="picture"
                  //         action="//jsonplaceholder.typicode.com/posts/"
                  //       >
                  //         <button>
                  //           <Icon icon="file-pdf-o" size="2x" /> <br />
                  //           <div style={{ marginTop: 3, fontSize: 10 }}>เพิ่มไฟล์</div>
                  //         </button>
                  //       </Uploader>
                  //     </>
                  //   )
                  // }
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </div>

      {!isViewMode && (
        <div style={{ marginTop: 10 }}>
          <Row>
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                onClick={() => handleOnClickAddNewData()}
                disabled={
                  tableData.find((i) => i.id.indexOf('sendTax') > 0) || isSendTax || isAddDisabled
                }
                style={{ marginLeft: 5 }}
              >
                {'เพิ่มรายการ'}
              </IconButton>
            </Col>
          </Row>
        </div>
      )}

      <ConfirmWidget
        title={`ยืนยันการลบงวดเงิน`}
        show={isShowConfirmDelete}
        detail={`กรุณายืนยันการลบงวดเงิน`}
        onCancle={() => setIsShowConfirmDelete(false)}
        // onConfirm={handleOnConfirmDelete}
      />

      {/* ค้นหารายการ-บุคคลที่ต้องการจ่ายให้ */}
      {showModalExpenseFor && (
        <PayeeModalWidget
          title={'ค้นหารายการ ผู้รับเงิน'}
          projectCode={projectCode}
          isViewMode={IsModalModalExpenseForViewOnly}
          show={showModalExpenseFor}
          onSelect={handleSelectVender}
          onClose={cancelShowModalExpenseFor}
          expenseForId={expenseForId}
          isSubproject={isSubprojectReceiver}
        />
      )}

      {/* กรณีเลือกราการ ประเภทจ่าย = ค่าครุภัณฑ์ */}
      <ExpenseRecordDurableArticlesModal
        showModalDurableArticles={showModalDurableArticles}
        setShowModalDurableArticles={setShowModalDurableArticles}
        schema={schema.durableArticlesForm}
        data={tableData[indexForEditExpenseFor]?.dutableArticles || null}
        onSubmitDurableArticles={handleSubmitDurableArticles}
        onPreview={onPreview}
        onDownload={onDownload}
        viewMode={IsModalDurableArticlesViewOnly}
      />

      {/* <div className="modal-container">
        <Modal show={showModalDurableArticles} onHide={cancelShowModalDurableArticles}>
          <Modal.Header>
            <Modal.Title>ค่าครุภัณฑ์</Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: 'unset' }}>
            <Container style={{ height: '100%' }}>
              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesAmount.validators,
                      schema.durableArticlesForm?.durableArticlesAmount.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesAmount.name]} />
                  <Input
                    name={schema.durableArticlesForm?.durableArticlesAmount.name}
                    defaultValue={schema.durableArticlesForm?.durableArticlesAmount.value}
                    type="number"
                    inputRef={register(isValidators(schema.durableArticlesForm?.durableArticlesAmount.validators))}
                    placeholder={'ระบุ' + schema.durableArticlesForm?.durableArticlesAmount.label}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesName.validators,
                      schema.durableArticlesForm?.durableArticlesName.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesName.name]} />
                  <Input
                    name={schema.durableArticlesForm?.durableArticlesName.name}
                    defaultValue={schema.durableArticlesForm?.durableArticlesName.value}
                    inputRef={register(isValidators(schema.durableArticlesForm?.durableArticlesName.validators))}
                    placeholder={'ระบุ' + schema.durableArticlesForm?.durableArticlesName.label}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesPrice.validators,
                      schema.durableArticlesForm?.durableArticlesPrice.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesPrice.name]} />
                  <Input
                    name={schema.durableArticlesForm?.durableArticlesPrice.name}
                    defaultValue={schema.durableArticlesForm?.durableArticlesPrice.value}
                    inputRef={register(isValidators(schema.durableArticlesForm?.durableArticlesPrice.validators))}
                    placeholder={'ระบุ' + schema.durableArticlesForm?.durableArticlesPrice.label}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesType.validators,
                      schema.durableArticlesForm?.durableArticlesType.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesType.name]} />
                  <Controller
                    name={schema.durableArticlesForm?.durableArticlesType.name}
                    control={control}
                    defaultValue={schema.durableArticlesForm?.durableArticlesType.value}
                    rules={isValidators(schema.durableArticlesForm?.durableArticlesType.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          searchable={false}
                          data={schema.durableArticlesForm?.durableArticlesType.options}
                          value={props.value}
                          block
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesDocumentDate.validators,
                      schema.durableArticlesForm?.durableArticlesDocumentDate.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesDocumentDate.name]} />
                  <Controller
                    key={schema.durableArticlesForm?.durableArticlesDocumentDate.name}
                    name={schema.durableArticlesForm?.durableArticlesDocumentDate.name}
                    control={control}
                    defaultValue={
                      // moment(schema.durableArticlesForm?.reportDate.value).format('YYYY-MM-DD')
                      // schema.durableArticlesForm?.reportDate.value
                      //   ? moment(schema.durableArticlesForm?.reportDate.value, 'DD-MM-YYYY').toDate()
                      //   : moment().startOf('day').toDate()
                      moment().startOf('day').toDate()
                    }
                    rules={isValidators(schema.durableArticlesForm?.durableArticlesDocumentDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD-MM-YYYY"
                          locale={LOCAL_DAY_TH}
                          block
                          value={props.value}
                          onChange={(value) => {
                            props.onChange(value)
                            // onChangeReportDate(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesAttachFiles.validators,
                      schema.durableArticlesForm?.durableArticlesAttachFiles.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesAttachFiles.name]} />
                  <Controller
                    key={schema.durableArticlesForm?.durableArticlesAttachFiles.name}
                    name={schema.durableArticlesForm?.durableArticlesAttachFiles.name}
                    control={control}
                    rules={isValidators(schema.durableArticlesForm?.durableArticlesAttachFiles.validators)}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          autoUpload={false}
                          disabled={schema.durableArticlesForm?.durableArticlesAttachFiles.disabled}
                          fileListVisible={true}
                          listType="picture-text"
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let file = fileList[fileList.length - 1]

                              if (isImageOrPdf(file.blobFile.type)) {
                                props.onChange(fileList)
                                setFileTypeError(false)
                              } else {
                                setFileTypeError(true)
                              }
                            }
                          }}
                          draggable
                        >
                          <div style={{ lineHeight: '100px' }}>
                            <Icon size="4x" icon="upload2" />
                            <small
                              style={{
                                marginTop: '-70px',
                                display: 'block',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </small>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
              </Row>

              <Row style={{ marginTop: 10, width: '95%' }}>
                <Col lg={8} md={8} sm={24} xs={24} style={{ textAlign: 'right' }}>
                  <ControlLabel>
                    {requiredFiled(
                      schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.validators,
                      schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.label
                    )}
                  </ControlLabel>
                </Col>
                <Col lg={16} md={16} sm={24} xs={24}>
                  <ErrorMessage error={errors[schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.name]} />
                  <Controller
                    key={schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.name}
                    name={schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.name}
                    control={control}
                    rules={isValidators(schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.validators)}
                    defaultValue={''}
                    render={(props) => {
                      return (
                        <Uploader
                          autoUpload={false}
                          disabled={schema.durableArticlesForm?.durableArticlesDocumentAttachFiles.disabled}
                          fileListVisible={true}
                          listType="picture-text"
                          fileList={props.value || []}
                          onChange={(fileList) => {
                            if (isEmpty(fileList)) {
                              props.onChange(undefined)
                            } else {
                              let file = fileList[fileList.length - 1]

                              if (isImageOrPdf(file.blobFile.type)) {
                                props.onChange(fileList)
                                setFileTypeError(false)
                              } else {
                                setFileTypeError(true)
                              }
                            }
                          }}
                          draggable
                        >
                          <div style={{ lineHeight: '100px' }}>
                            <Icon size="4x" icon="upload2" />
                            <small
                              style={{
                                marginTop: '-70px',
                                display: 'block',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                            </small>
                          </div>
                        </Uploader>
                      )
                    }}
                  />
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer>
            <Button appearance="primary" onClick={cancelShowModalDurableArticles}>
              บันทึก
            </Button>
            <Button appearance="subtle" onClick={cancelShowModalDurableArticles}>
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
      </div> */}
    </>
  )
}

const styleCenter = {
  textAlign: 'center',
}
